import { render } from "./market-watch-comex.vue?vue&type=template&id=4d54c8ab&scoped=true"
import script from "./market-watch-comex.vue?vue&type=script&lang=js"
export * from "./market-watch-comex.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./market-watch-comex.vue?vue&type=style&index=1&id=4d54c8ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d54c8ab"]])

export default __exports__